<template>
    <b-modal :id="modalId"
             size="xl"
             :ok-only="true"
             align="left">
      <!--<b-card :header="distressDetails.name">-->
      <!--</b-card>-->
      <h1 slot="modal-title">{{distressDetails.name}}</h1>


      <b-row>
        <b-col>
        <h2>Basic Description</h2>
        {{distressDetails.descriptionBasic}}
        </b-col>
        <b-col>
          <h2>Severity Levels</h2>
          <div v-for="s in distressDetails.descriptionSeverity">
            <p>* {{s}}</p>
          </div>
        </b-col>
      </b-row>

      <hr size="10">

      <h2>Guidance</h2>
      <div v-for="g in distressDetails.selectionGuidance">
        <p>* {{g}}</p>
      </div>

      <hr size="10">

      <b-row>
        <b-col style="font-style: italic">
          <p>For more technical details and background information regarding individual pavement
            distresses for low volume roads, please visit the
            <a style="font-weight: bold;" target="_blank" href="http://rxpave.wpengine.com/rxpave-resources/pavement-distress-profiles/">Pavement Distress Profiles.</a></p>

          <p>For example photos of individual and combinations of pavement distresses,
            please visit the
            <a style="font-weight:bold;" target="_blank" href="http://rxpave.wpengine.com/rxpave-resources/distress-photo-gallery/">Distress Photo Gallery.</a></p>
        </b-col>
      </b-row>

    </b-modal>
</template>

<script>
  import DistressImageContainer from './DistressImageContainer'

  export default {
    name: "DistressInputModal",
    components: {
      DistressImageContainer
    },
    props: {
      distressDetails: {
        /*
        name -> String
        descriptionBasic -> String
        impact -> String
        possibleCauses -> String
        descriptionDetailed -> String
        selectionGuidance -> List[String]
        descriptionSeverity -> List[String]
         */
        required: true,
        type: Object
      },
      modalId: {
        type: String,
        required: true
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>